//libs
import React, { memo } from 'react';

//styles
import { CustomWishlist } from './styles';

//hooks
import { useRemoteConfig } from 'shared/store/remoteConfigs/hooks';

const WishlistWrapper = ({
  item,
  transformedImpressionsProduct,
  onClickInteraction,
}: {
  item: Listing.IProduct;
  transformedImpressionsProduct: any;
  onClickInteraction?: (data: string) => void;
}) => {
  const { desktop: isPriceReveal, salePromotionConfig } = useRemoteConfig('priceReveal');

  const WISHLIST_ICON_SIZE = 24;

  const wishlistMetaData = {
    categoryName: 'categoryName',
    discountPercent: item.discount,
    MRP: item.price,
    productName: item.subTitle,
    productSKU: item.sku,
    discountedPrice: item.discountedPrice,
    productBrandName: item.title,
    isOutOfStock: Boolean(item.isOutOfStock),
    productTags: item?.tag,
    isPriceReveal: isPriceReveal && item?.price_reveal_data && item?.price_reveal_data.sp > 0,
    isSalePriceLive: salePromotionConfig?.desktop && item.sale_price_live_flag,
    isProductOffersAvailable: 'NA',
    categoryLevels: item?.primary_categories_json_all,
    impressionsData: transformedImpressionsProduct,
    ...(item.type ? { productType: item.type } : {}),
    ...(item?.badge_new?.title || item?.badge?.title
      ? { productBadge: item?.badge_new?.title || item?.badge?.title }
      : {}),
  };
  return (
    <CustomWishlist
      size={WISHLIST_ICON_SIZE}
      key={item.id}
      displayWishlistMessage={true}
      isOutOfStock={item.isOutOfStock}
      productId={item.id}
      price={item.price}
      productName={item.subTitle}
      productSKU={item.sku}
      discountedPrice={item.discountedPrice}
      productBrand={item.title}
      type={item.type}
      isPriceReveal={item?.price_reveal_data && item?.price_reveal_data.sp}
      isNewWishlistNudge={true}
      trackingMetaData={wishlistMetaData}
      onClickInteraction={onClickInteraction}
    />
  );
};

export default memo(WishlistWrapper);
